import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledDirectoryEmptyStateComponent } from "./directory-empty-state-component.scss";
class DirectoryEmptyStateComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsxs(StyledDirectoryEmptyStateComponent, {
            className: "directory-empty-state-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "empty-state-image-container",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: "/static/img/empty-states/clouds-empty-state.png"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "empty-state-title",
                    children: "No results were found"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "empty-state-subtitle",
                    children: "What you are looking for is not being found, check your spelling of use a different word"
                })
            ]
        });
    }
}
export { DirectoryEmptyStateComponent as default };
